import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7c58cb96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organizations-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Organizations", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Organizations", -1))
const _hoisted_5 = { class: "controls" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<option value=\"10\" data-v-7c58cb96>10</option><option value=\"20\" data-v-7c58cb96>20</option><option value=\"30\" data-v-7c58cb96>30</option><option value=\"100\" data-v-7c58cb96>100</option><option value=\"all\" data-v-7c58cb96>All</option>", 5)
const _hoisted_11 = [
  _hoisted_6
]
const _hoisted_12 = { class: "organizations-table" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Actions", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.name) = $event)),
        placeholder: "Filter by name"
      }, null, 512), [
        [_vModelText, _ctx.filters.name]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.districtName) = $event)),
        placeholder: "Filter by district"
      }, null, 512), [
        [_vModelText, _ctx.filters.districtName]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.address) = $event)),
        placeholder: "Filter by address"
      }, null, 512), [
        [_vModelText, _ctx.filters.address]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.city) = $event)),
        placeholder: "Filter by city"
      }, null, 512), [
        [_vModelText, _ctx.filters.city]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemsPerPage) = $event))
      }, _hoisted_11, 512), [
        [_vModelSelect, _ctx.itemsPerPage]
      ]),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exportToCSV && _ctx.exportToCSV(...args)))
      }, "Export CSV"),
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)))
      }, "Export Excel"),
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addOrganization && _ctx.addOrganization(...args))),
        class: "create-button"
      }, " Add Organization ")
    ]),
    _createElementVNode("table", _hoisted_12, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortBy('name'))),
            class: "sortable"
          }, [
            _createTextVNode(" Name "),
            (_ctx.sortColumn === 'name')
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: _ctx.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down',
                  class: "sort-icon"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("th", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortBy('districtName'))),
            class: "sortable"
          }, [
            _createTextVNode(" District "),
            (_ctx.sortColumn === 'districtName')
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: _ctx.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down',
                  class: "sort-icon"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("th", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortBy('address'))),
            class: "sortable"
          }, [
            _createTextVNode(" Address "),
            (_ctx.sortColumn === 'address')
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: _ctx.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down',
                  class: "sort-icon"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("th", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortBy('city'))),
            class: "sortable"
          }, [
            _createTextVNode(" City "),
            (_ctx.sortColumn === 'city')
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: _ctx.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down',
                  class: "sort-icon"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_13
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAndFilteredOrganizations, (organization) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: organization.id
          }, [
            _createElementVNode("td", null, _toDisplayString(organization.name), 1),
            _createElementVNode("td", null, _toDisplayString(organization.districtName || ""), 1),
            _createElementVNode("td", null, _toDisplayString(organization.address), 1),
            _createElementVNode("td", null, _toDisplayString(organization.city), 1),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.viewOrganization(organization.id)),
                class: "view-button"
              }, " View ", 8, _hoisted_14),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.editOrganization(organization.id)),
                class: "edit-button"
              }, " Edit ", 8, _hoisted_15)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}